import { ref } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import {
	APP_LOCALHOST,
	APP_MODE,
	APP_TESTY,
	APP_USTAWOTEKA,
	IS_PATH_USTAWOTEKA,
} from '@/config/appModel';
import { adminUrl } from '@/config/externalLinks';

const Default = () => import('@/views/Layout/Logged/Default.vue');
const UDefault = () => import('@/viewsUstawoteka/Layout/Logged/UDefault.vue');
const DefaultUnlogged = () => import('@/views/Layout/Unlogged/DefaultUnlogged.vue');
const HomePage = () => import('@/views/HomePage/HomePage.vue');
const News = () => import('@/components/organisms/News/News.vue');
const NewsPreview = () => import('@/components/organisms/News/NewsPreview.vue');
const Login = () => import('@/views/Login/Login.vue');
const ULogin = () => import('@/viewsUstawoteka/Login/ULogin.vue');
const Register = () => import('@/views/Register/Register.vue');
const URegister = () => import('@/viewsUstawoteka/Register/URegister.vue');
const ResetPassword = () => import('@/views/ResetPassword/ResetPassword.vue');
const UResetPassword = () => import('@/viewsUstawoteka/ResetPassword/UResetPassword.vue');
const EmailVerify = () => import('@/views/EmailVerify/EmailVerify.vue');
const UEmailVerify = () => import('@/viewsUstawoteka/EmailVerify/UEmailVerify.vue');
const Dashboard = () => import('@/views/Dashboard/Dashboard.vue');
const UDashboard = () => import('@/viewsUstawoteka/Dashboard/UDashboard.vue');
const Settings = () => import('@/views/Settings/Settings.vue');
const USettings = () => import('@/viewsUstawoteka/Settings/USettings.vue');
const ChangePassword = () => import('@/views/ResetPassword/ChangePassword.vue');
const UChangePassword = () => import('@/viewsUstawoteka/ResetPassword/UChangePassword.vue');
const EmailVerifyVerified = () => import('@/views/EmailVerify/EmailVerifyVerified.vue');
const PrivacyPolicy = () => import('@/views/PrivacyPolicy/PrivacyPolicy.vue');
const UPrivacyPolicy = () => import('@/viewsUstawoteka/PrivacyPolicy/UPrivacyPolicy.vue');
const Rules = () => import('@/views/Rules/Rules.vue');
const URules = () => import('@/viewsUstawoteka/Rules/URules.vue');
const Contact = () => import('@/views/Contact/Contact.vue');
const UContact = () => import('@/viewsUstawoteka/Contact/UContact.vue');
const EmailChangeVerify = () => import('@/views/EmailVerify/EmailChangeVerify.vue');
const UEmailChangeVerify = () => import('@/viewsUstawoteka/EmailVerify/UEmailChangeVerify.vue');
const NewTests = () => import('@/views/NewTests/NewTests.vue');
const Statistics = () => import('@/views/Statistics/Statistics.vue');
const CreateNormalTest = () => import('@/views/NewTests/CreateNormalTest.vue');
const CreateExamTest = () => import('@/views/NewTests/CreateExamTest.vue');
const TestSettings = () => import('@/views/NewTests/TestSettings.vue');
const CreateTestTest = () => import('@/views/NewTests/CreateTestTest.vue');
const CreateTestFromChanges = () => import('@/views/NewTests/CreateTestFromChanges.vue');
const CreateTestOther = () => import('@/views/NewTests/CreateTestOther.vue');
const ContinueTest = () => import('@/views/ContinueTest/ContinueTest.vue');
const FinishedTests = () => import('@/views/FinishedTests/FinishedTests.vue');
const FinishedTestSummary = () => import('@/views/FinishedTests/FinishedTestSummary.vue');
const RunTest = () => import('@/views/RunTest/RunTest.vue');
const QuestionsList = () => import('@/views/Questions/QuestionsList.vue');
const Repeats = () => import('@/views/Repeats/Repeats.vue');
const Games = () => import('@/views/Games/Games.vue');
const GamesNew = () => import('@/views/Games/GamesNew.vue');
const GamesView = () => import('@/views/Games/GamesView.vue');
const Shop = () => import('@/views/Shop/Shop.vue');
const ShopForm = () => import('@/views/Shop/ShopForm.vue');
const PaymentSummary = () => import('@/views/Shop/PaymentSummary.vue');
const UShop = () => import('@/viewsUstawoteka/Shop/UShop.vue');
const UShopForm = () => import('@/viewsUstawoteka/Shop/UShopForm.vue');
const UPaymentSummary = () => import('@/viewsUstawoteka/Shop/UPaymentSummary.vue');
const GamesJoin = () => import('@/views/Games/GamesJoin.vue');
const GamesRun = () => import('@/views/Games/GamesRun.vue');
const FinishedGamesSummary = () => import('@/views/FinishedTests/FinishedGamesSummary.vue');
const RulesPerTest = () => import('@/views/Rules/RulesPerTest.vue');
const UDefaultUnlogged = () => import('@/viewsUstawoteka/Layout/Unlogged/UDefaultUnlogged.vue');
const UHomePage = () => import('@/viewsUstawoteka/HomePage/UHomePage.vue');
const UAudioPage = () => import('@/viewsUstawoteka/AudioPage/UAudioPage.vue');

const adminRoutes = {
	path: '/admin/:pathMatch(.*)*',
	redirect: to => {
		const subPath = to.params.pathMatch
			? (Array.isArray(to.params.pathMatch) ? to.params.pathMatch.join('/') : String(to.params.pathMatch))
			: '';
		window.location.href = adminUrl(subPath);
		return '/';
	},
};

let routes: any[] = [];
if (APP_MODE === APP_TESTY || APP_MODE === APP_LOCALHOST) {
	routes = [
		adminRoutes,
		{
			path: '/',
			name: 'DefaultUnlogged',
			component: DefaultUnlogged,
			children: [
				{
					path: '/',
					name: 'HomePage',
					component: HomePage
				},
				{
					path: '/lista/aktualnosci',
					name: 'News',
					component: News
				},
				{
					path: '/aktualnosci/:slug',
					name: 'NewsPreview',
					component: NewsPreview
				},
				{
					path: '/login',
					name: 'Login',
					component: Login
				},
				{
					path: '/register',
					name: 'Register',
					component: Register
				},
				{
					path: '/password/reset',
					name: 'ResetPassword',
					component: ResetPassword
				},
				{
					path: '/password/reset/:uuid',
					name: 'ChangePassword',
					component: ChangePassword
				},
				{
					path: '/email/verify',
					name: 'EmailVerify',
					component: EmailVerify
				},
				{
					path: '/email/verify/:id/:hash',
					name: 'EmailVerifyVerified',
					component: EmailVerifyVerified
				},
				{
					path: '/informacje/polityka-prywatnosci',
					name: 'PrivacyPolicy',
					component: PrivacyPolicy
				},
				{
					path: '/informacje/regulamin',
					name: 'Rules',
					component: Rules
				},
				{
					path: '/przepisy-prawne/:id',
					name: 'RulesPerTest',
					component: RulesPerTest
				},
				{
					path: '/kontakt',
					name: 'Contact',
					component: Contact
				},
				{
					path: '/verify/email/change/:token',
					name: 'EmailChangeVerify',
					component: EmailChangeVerify,
				},
			]
		},
		{
			path: '/login',
			name: 'UserLogged',
			component: Default,
			children: [
				{
					path: '/app/start',
					name: 'Dashboard',
					component: Dashboard
				},
				{
					path: '/app/user',
					name: 'Settings',
					component: Settings
				},
				{
					path: '/app/tests/new',
					name: 'NewTests',
					component: NewTests
				},
				{
					path: '/app/tests/normal',
					name: 'CreateNormalTest',
					component: CreateNormalTest
				},
				{
					path: '/app/tests/prev-exam',
					name: 'CreateExamTest',
					component: CreateExamTest
				},
				{
					path: '/app/stats',
					name: 'Statistics',
					component: Statistics
				},
				{
					path: '/app/tests/normal/settings',
					name: 'TestNormalSettings',
					component: TestSettings
				},
				{
					path: '/app/tests/prev-exam/settings',
					name: 'TestExamSettings',
					component: TestSettings
				},
				{
					path: '/app/tests/other-test/settings',
					name: 'TestOtherSettings',
					component: TestSettings
				},
				{
					path: '/app/tests/changes-test/settings',
					name: 'TestChangesSettings',
					component: TestSettings
				},
				{
					path: '/app/tests/mock-exam',
					name: 'CreateTestTest',
					component: CreateTestTest
				},
				{
					path: '/app/tests/changed-test',
					name: 'CreateTestFromChanges',
					component: CreateTestFromChanges
				},
				{
					path: '/app/tests/other',
					name: 'CreateTestOther',
					component: CreateTestOther
				},
				{
					path: '/app/tests/continue',
					name: 'ContinueTest',
					component: ContinueTest
				},
				{
					path: '/app/tests/ended',
					name: 'FinishedTests',
					component: FinishedTests
				},
				{
					path: '/app/tests/ended/summary/:id',
					name: 'FinishedTestSummary',
					component: FinishedTestSummary
				},
				{
					path: '/app/tests/run/:id',
					name: 'RunTest',
					component: RunTest
				},
				{
					path: '/app/questions/list',
					name: 'QuestionsList',
					component: QuestionsList
				},
				{
					path: '/app/questions/repeat',
					name: 'Repeats',
					component: Repeats
				},
				{
					path: '/app/games',
					name: 'Games',
					component: Games
				},
				{
					path: '/app/games/new',
					name: 'GamesNew',
					component: GamesNew
				},
				{
					path: '/app/games/new/:hashKey',
					name: 'GamesNewWithGame',
					component: GamesNew
				},
				{
					path: '/app/games/view/exam/:hashKey',
					name: 'GamesViewExam',
					component: GamesView
				},
				{
					path: '/app/games/view/homework/:hashKey',
					name: 'GamesViewHomework',
					component: GamesView
				},
				{
					path: '/app/games/view/race/:hashKey',
					name: 'GamesViewRace',
					component: GamesView
				},
				{
					path: '/app/games/join/:hashKey',
					name: 'GamesJoin',
					component: GamesJoin
				},
				{
					path: '/app/games/run/exam/:hashKey',
					name: 'GamesExamRun',
					component: GamesRun,
				},
				{
					path: '/app/games/run/race/:hashKey/:id',
					name: 'GamesRaceRun',
					component: GamesRun,
				},
				{
					path: '/app/games/run/homework/:hashKey',
					name: 'GamesHomeworkRun',
					component: GamesRun,
				},
				{
					path: '/app/games/ended/summary/:id',
					name: 'FinishedGamesSummary',
					component: FinishedGamesSummary,
				},
				{
					path: '/app/shop',
					name: 'Shop',
					component: Shop
				},
				{
					path: '/app/shop/subscribe/form',
					name: 'ShopSubscribeForm',
					component: ShopForm
				},
				{
					path: '/app/shop/mix-form',
					name: 'ShopMixForm',
					component: ShopForm
				},
				{
					path: '/app/shop/form/:packageId/:months/:type',
					name: 'ShopForm',
					component: ShopForm
				},
				{
					path: '/app/shop/return/',
					name: 'PaymentSummary',
					component: PaymentSummary
				},
			],
		},
	];
} else if (APP_MODE === APP_USTAWOTEKA) {
	routes = [
		adminRoutes,
		{
			path: '/',
			name: 'UDefaultUnlogged',
			component: UDefaultUnlogged,
			children: [
				{
					path: '/',
					name: 'UHomePage',
					component: UHomePage
				},
				{
					path: '/lista/aktualnosci',
					name: 'UNews',
					component: News
				},
				{
					path: '/aktualnosci/:slug',
					name: 'UNewsPreview',
					component: NewsPreview
				},
				{
					path: '/login',
					name: 'ULogin',
					component: ULogin
				},
				{
					path: '/register',
					name: 'URegister',
					component: URegister
				},
				{
					path: '/password/reset',
					name: 'UResetPassword',
					component: UResetPassword
				},
				{
					path: '/password/reset/:uuid',
					name: 'UChangePassword',
					component: UChangePassword
				},
				{
					path: '/email/verify',
					name: 'UEmailVerify',
					component: UEmailVerify
				},
				{
					path: '/email/verify/:id/:uuid',
					name: 'UEmailVerifyVerified',
					component: EmailVerifyVerified
				},
				{
					path: '/informacje/polityka-prywatnosci',
					name: 'UPrivacyPolicy',
					component: UPrivacyPolicy
				},
				{
					path: '/informacje/regulamin',
					name: 'URules',
					component: URules
				},
				{
					path: '/kontakt',
					name: 'UContact',
					component: UContact
				},
				{
					path: '/verify/email/change/:token',
					name: 'UEmailChangeVerify',
					component: UEmailChangeVerify,
				},
			]
		},
		{
			path: '/login',
			name: 'UUserLogged',
			component: UDefault,
			children: [
				{
					path: '/app/start',
					name: 'UDashboard',
					component: UDashboard
				},
				{
					path: '/app/start/all',
					name: 'UDashboardAll',
					component: UDashboard
				},
				{
					path: '/app/start/audio',
					name: 'UDashboardAudio',
					component: UDashboard
				},
				{
					path: '/app/user',
					name: 'USettings',
					component: USettings
				},
				{
					path: '/app/shop',
					name: 'UShop',
					component: UShop
				},
				{
					path: '/app/shop/subscribe/form',
					name: 'UShopSubscribeForm',
					component: UShopForm
				},
				{
					path: '/app/shop/mix-form',
					name: 'UShopMixForm',
					component: UShopForm
				},
				{
					path: '/app/shop/form/:packageId/:months/:type',
					name: 'UShopForm',
					component: UShopForm
				},
				{
					path: '/app/shop/return/',
					name: 'UPaymentSummary',
					component: UPaymentSummary
				},
				{
					path: '/app/legal/:id',
					name: 'UAudioPage',
					component: UAudioPage
				},
			],
		},
	];
}
const prefixRoutesForPathUstawoteka = (list: any[]): any[] => {
	if (!IS_PATH_USTAWOTEKA) {
		return list;
	}
	const PREFIX = '/ustawoteka';
	const walk = (r: any): any => {
		if (r.redirect && typeof r.path === 'string' && r.path.startsWith('/admin')) {
			return r;
		}
		const nextPath = r.path === '/'
			? PREFIX
			: r.path?.startsWith('/')
				? `${PREFIX}${r.path}`
				: r.path;
		const next: any = { ...r, path: nextPath };
		if (Array.isArray(r.children)) {
			next.children = r.children.map(walk);
		}
		return next;
	};
	return list.map(walk);
};

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: prefixRoutesForPathUstawoteka(routes),
});

export const previousRoute = ref<string | null>(null);

router.beforeEach((to, from, next) => {
	previousRoute.value = from.name;

	if (
		IS_PATH_USTAWOTEKA
		&& typeof to.path === 'string'
		&& to.path !== '/ustawoteka'
		&& !to.path.startsWith('/ustawoteka/')
	) {
		next({
			path: `/ustawoteka${to.path}`,
			query: to.query,
			hash: to.hash,
			replace: true,
		});
		return;
	}

	if (to.matched.some((record) => record.meta.requiresAdmin)) {
		const isLogged = localStorage.getItem('isLogged') === '1';
		if (!isLogged) {
			next({ name: APP_MODE === APP_USTAWOTEKA ? 'ULogin' : 'Login' });
			return;
		}
	}

	next();
});

export default router;
